import { ChangeDetectorRef, Component, forwardRef, Input, OnDestroy } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import {
  TAG_CATEGORY_COMBO_UI_CONDITION_FIELD
} from 'app/query-common/rule-interfaces/TagCategoryResponsesRuleField';
import { TagsAdvancedRuleField } from 'app/query-common/rule-interfaces/TagsAdvancedRuleField';
import { WithDisposableSubject } from 'core/mixins/with-disposable-subject';
import { Rule, RuleSet } from 'query-builder/query.interfaces';

@Component({
  selector: 'app-fields-advanced-combo-input',
  templateUrl: './fields-advanced-combo.component.html',
  styleUrls: ['./fields-advanced-combo.component.scss'],
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => FieldsAdvancedComboInputComponent), multi: true },
  ]
})
export class FieldsAdvancedComboInputComponent extends WithDisposableSubject()
  implements ControlValueAccessor, OnDestroy {

  @Input() targetType: 'EntityType' | 'EntityConnectionType' = 'EntityType';
  @Input() campaignId: string;

  includeExcludeRules = {
    includeRule: null,
    excludeRule: null,
  };

  get value(): any {
    const transformed = {
      condition: 'and',
      ui_condition_field: TAG_CATEGORY_COMBO_UI_CONDITION_FIELD,
      rules: [
        this.includeExcludeRules.includeRule,
        this.includeExcludeRules.excludeRule
      ]
    };

    return transformed;
  }

  set value(value: any) {
    // noop
  }

  public onChangeCallback: () => void;
  public onTouchedCallback: () => any;

  constructor(
    private _cd: ChangeDetectorRef
  ) {
    super();
  }


  writeValue(obj: RuleSet): void {
    if (obj != null) {
      this.includeExcludeRules = this.getIncludeExcludeRuleValues(obj);
      this.handleDataChange();
    }
  }

  isAny(obj: Rule) {
    return obj?.operator?.toLowerCase().includes('any');
  }

  getIncludeExcludeRuleValues(obj: RuleSet): any {
    return {
      includeRule: this.getIncludeRule(obj),
      excludeRule: this.getExcludeRule(obj)
    };
  }

  getIncludeRule(obj: RuleSet): Rule {
    const rules = obj?.rules || [];
    return (rules.find((rule: Rule) => rule.operator?.toLowerCase().startsWith('include')) as TagsAdvancedRuleField) ||
    {
      field: 'tag_category_responses',
      entity: this.targetType === 'EntityConnectionType' ? 'entity_connection' : 'entity',
      operator: 'include having any',
      value: {
        tag_category_ids: []
      }
    };
  }

  getExcludeRule(obj: RuleSet): Rule {
    const rules = obj?.rules || [];
    return (rules.find((rule: Rule) => rule.operator?.toLowerCase().startsWith('exclude')) as TagsAdvancedRuleField) ||
    {
      field: 'tag_category_responses',
      entity: this.targetType === 'EntityConnectionType' ? 'entity_connection' : 'entity',
      operator: 'exclude having any',
      value: {
        tag_category_ids: []
      }
    };
  }

  registerOnChange(fn: any): void {
    this.onChangeCallback = () => fn(this.value);
  }

  registerOnTouched(fn: any): void {
    this.onTouchedCallback = () => fn(this.value);
  }

  private handleDataChange(): void {
    this._cd.markForCheck();
    if (this.onChangeCallback) {
      this.onChangeCallback();
    }
  }
}
